// ** Reducers Imports
import navbar from './navbar'
import users from '@src/views/pages/user/store'
import customer from '@src/views/pages/customer/store'
import invoice from '@src/views/pages/transaction/store'
import reports from '@src/views/pages/reports/store'
import layout from './layout'
import auth from './authentication'
import nonQualified from '@src/views/pages/reports/nonqualified/store'
import chargeBack from '@src/views/pages/reports/chargeback/store'
import batchTransaction from '@src/views/pages/batch-transaction/store'
import tip from '@src/views/pages/reports/tip/store'
import ivr from '@src/views/pages/ivr/store'
import recurring from '@src/views/pages/recurring/store'
import merchantuser from '@src/views/pages/merchant-user/store'
import adminTransaction from '@src/views/pages/admin-transaction/store'

// ** New State Management Slices
import statementReducer from './statementSlice'
import userReducer from './userSlice'
import transactionReducer from './transactionSlice'
import paymentReducer from './paymentSlice'
import uiReducer from './uiSlice'
import gatewayProfile from './slices/gatewayProfileSlice'

const rootReducer = {
  auth,
  users,
  navbar,
  layout,
  invoice,
  customer,
  reports,
  nonQualified,
  chargeBack,
  batchTransaction,
  tip,
  ivr,
  recurring,
  merchantuser,
  adminTransaction,
  gatewayProfile,
  // ** New State Management
  statements: statementReducer,
  userSlice: userReducer,
  transactions: transactionReducer,
  payments: paymentReducer,
  ui: uiReducer
}

export default rootReducer
